<script>
import Translatable from '@src/mixins/translatable.js'
import SanitizerMixin from '@src/mixins/sanitizer-mixin.js'

export default {
  props: {
    categoryData: {
      type: Array,
      // required: true
    },
  },
  mixins: [Translatable, SanitizerMixin],
  methods: {
    toggleSpoiler(event) {
      const activeSpoilers = document.querySelectorAll(
        '.spoiler-content.active'
      )
      const spoilerContent =
        event.currentTarget.parentNode.querySelector('.spoiler-content')
      const arrowContent =
        event.currentTarget.parentNode.querySelector('.arrow')

      spoilerContent.classList.toggle('active')
      arrowContent.classList.toggle('active')
      activeSpoilers.forEach((spoiler) => {
        if (spoiler !== spoilerContent) {
          spoiler.classList.toggle('active')
          spoiler.parentNode.querySelector('.arrow').classList.toggle('active')
        }
      })
    },
  },
  mounted() {
    const firstSpoiler = document.querySelector('.spoiler-content')
    const arrowContent = document.querySelector('.arrow')
    firstSpoiler && firstSpoiler.classList.toggle('active')
    arrowContent && arrowContent.classList.toggle('active')
  },
}
</script>

<template>
  <div class="content">
    <div v-for="benefit in categoryData" :key="benefit.id" class="spoiler">
      <div class="spoiler-title-box" @click.prevent="toggleSpoiler">
        <h4 class="spoiler-title-text">
          {{ getTranslatedContent('title', benefit.content) }}
        </h4>
        <div class="arrow"></div>
      </div>
      <div class="spoiler-content hidden" @click="toggleSpoiler">
        <p class="spoiler-text" v-html="description(benefit.content)"></p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.content {
  height: auto;
  margin-right: 15px;
}

.spoiler {
  margin-top: 2px;
  border-top: 1px solid $dark-gray;
  user-select: none;
}

.spoiler:first-child {
  border-top: 1px solid $white;
}

.spoiler:last-child {
  border-bottom: 1px solid $dark-gray;
}

.spoiler-title-box {
  cursor: pointer;
  height: 70px;
  background-color: $white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.spoiler-title-text {
  margin-left: 28px;
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 18px;
  line-height: 23px;
  max-width: 820px;
  color: $black;
}

.arrow {
  background: url('../../assets/icons/tab-arrow-down.svg') center no-repeat;
  width: 24px;
  height: 24px;
  margin-right: 5px;

  &.active {
    background: url('../../assets/icons/tab-arrow-up.svg') center no-repeat;
  }
}

.spoiler-content {
  width: 100%;
  height: 0;
  visibility: hidden;
  background: $white;
  transition: height 0.25s ease-out;
  display: flex;
  justify-content: left;
  cursor: pointer;

  &.active {
    height: auto;
    visibility: visible;
  }
}

::v-deep.spoiler-text {
  width: 100%;
  margin: 0 0 15px 28px;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  color: $black;
  // opacity: 0.8;
  user-select: none;

  & em {
    font-style: italic;
  }

  & ul {
    margin-left: 20px;
    list-style: initial;
  }

  & strong {
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
  }

  & a {
    color: $gray;
    text-decoration: none;

    &:hover {
      color: $orange;
    }
  }

  & .ql-align-center {
    text-align: center;
  }
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {
  .spoiler-text,
  .spoiler-title-box,
  .spoiler-content,
  .spoiler {
    width: 100%;
  }

  .content {
    margin-right: 0px;
  }

  .spoiler-title-box {
    padding-top: 15px;
    padding-bottom: 15px;
    height: auto;
  }

  .spoiler-title-text {
    margin: 0;
    margin-left: 11px;
    max-width: 320px;
    font-size: 14px;
    line-height: 18px;
    text-align: left;
  }

  .spoiler-content {
    padding-right: 0px;
    padding-left: 0px;
  }

  .spoiler-text {
    margin-left: 11px;
    margin-right: 5px;
  }
}
</style>
